export default __webpack_public_path__ + "static/media/BizCollection2021Catalogue-400x482.e70c63b8.jpg";